import { className } from "../../tools/TypeUtilities";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { Operator } from "./Operator";

export class PrecedenceLevel
{
  fromLeft:boolean = true;
  operators:Operator[] = [];

  _expressionIndex:number;
  _operatorIndex:number;


  process( expressions:RJExpressionNode[] ):boolean
  {
    this.searchExpressionForOperators( expressions );      

    if ( this._operatorIndex == -1 )
    {
      return false;
    }

    var currentOperator = this.operators[ this._operatorIndex ];
    
    var changed = currentOperator.processStartNode( expressions, this._expressionIndex );

    if ( changed )
    {
      //console.log( "Processed", className( currentOperator ), currentOperator.tokenType, currentOperator.tokenValue );    
    }

    return changed;
  }

  searchExpressionForOperators( expressions:RJExpressionNode[] ):void
  {
    this._expressionIndex = this.fromLeft ? expressions.length : -1;
    this._operatorIndex   = -1;

    for ( let i = 0; i < this.operators.length; i++ )
    {
      var index = this.operators[ i ].findStartNodeIndex( expressions );

      if ( index === -1 )
      {
        continue;
      }

      if ( ! this._hasHigherPrecedence( index, this._expressionIndex ) )
      {
        continue;
      }

      this._expressionIndex = index;
      this._operatorIndex = i;
      
    }
  
  }

  _hasHigherPrecedence( i:number, e:number )
  {
    return this.fromLeft ? i < e : i > e;
  }
}